Librarian.VideoRecorderWindow = new Class({
    Extends: Librarian.Window,

    Binds: ["onChangeMode", "onCameraLoad", "onCameraError", "onScreenCaptureLoad", "onScreenCaptureError", "onScreenPipLoad",
            "onScreenPipError", "onDataAvailable", "record", "stop", "onStop", "updateTimer", "save", "onSave", "onSaveError"],

    options: {
        id: "VideoRecorderWindow",
        title: "Record Video",
        width: 800,
        height: 510,

        mode: "camera",

        videoOptions: {
            width: { ideal: 1280 },
            height: { ideal: 720 }
        },
        audioOptions: {
            sampleRate: 48000,
            channelCount: 1,
            volume: 1.0,
            echoCancellation: true,
            noiseSuppression: true
        },

        // Uploading options
        chunkUrl: null,
        completeUrl: null,
        importOptions: {},
        onComplete: null
    },

    mediaStream: null,
    recorder: null,
    chunks: null,

    initialize: function(options) {
        this.setOptions(options);

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/videorecorder.html";

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.setupElements();

        var modes = this.getElements(".video-mode");
        modes.addOnClick(this.onChangeMode);

        var recordButton = this.getElement("recordButton");
        if (recordButton) {
            recordButton.addOnClick(this.record);
        }

        var stopButton = this.getElement("stopButton");
        if (stopButton) {
            stopButton.addOnClick(this.stop);
        }

        var saveButton = this.getElement("saveButton");
        if (saveButton) {
            saveButton.addOnClick(this.save);
        }

        this.setupVideoRecorder();
    },

    setupVideoRecorder: function() {
        this.mediaStream = new MediaStream();

        var videoEl = this.getElement("liveVideo");
        if (videoEl) {
            videoEl.muted = true;
            videoEl.srcObject = this.mediaStream;
        }

        this.recorder = new MediaRecorder(this.mediaStream, { mimeType: "video/webm;codecs=h264" });
        this.recorder.ondataavailable = this.onDataAvailable;
        this.recorder.onstop = this.onStop;

        this.setMode(this.options.mode);
    },

    onChangeMode: function(e) {
        var mode = e.target.value;
        this.setMode(mode);
    },

    setMode: function(mode) {
        this.options.mode = mode;

        if (mode == "camera" && !this.cameraDisabled)
            this.enableCamera();
        else if (mode == "screen" && !this.screenDisabled)
            this.enableScreenCapture();
        else if (mode == "screenpip") {
            this.enableScreenPip();
        }
        else
            return;

        this.windowEl.getElement(".video-mode." + mode).select();
    },

    // #region Camera

    enableCamera: function() {
        if (this.cameraTracks) {
            this.setMediaTracks(this.cameraTracks);
            return;
        }

        navigator.mediaDevices.getUserMedia({
            video: this.options.videoOptions,
            audio: this.options.audioOptions
        }).then(this.onCameraLoad)
          .catch(this.onCameraError);
    },

    onCameraLoad: function (mediaStream) {
        this.cameraTracks = mediaStream.getTracks();

        this.setMediaTracks(this.cameraTracks);
    },

    onCameraError: function(error) {
        console.error("Camera error: " + error);

        this.cameraDisabled = true;

        if (!this.screenDisabled) {
            this.setMode("screen");
        }
    },

    // #endregion

    // #region Screen Capture

    enableScreenCapture: function() {
        if (this.screenCaptureTracks) {
            this.setMediaTracks(this.screenCaptureTracks);
            return;
        }

        var promises = [
            navigator.mediaDevices.getDisplayMedia({
                video: this.options.videoOptions
            }),
            navigator.mediaDevices.getUserMedia({
                audio: this.options.audioOptions
            }).catch($empty) // Ignore missing audio
        ];

        Promise.all(promises)
               .then(this.onScreenCaptureLoad)
               .catch(this.onScreenCaptureError);
    },

    onScreenCaptureLoad: function(results) {
        var videoStream = results[0];
        var audioStream = results[1];

        var tracks = videoStream.getTracks();
        if (audioStream)
            tracks = tracks.concat(audioStream.getTracks());

        this.screenCaptureTracks = tracks;

        this.setMediaTracks(this.screenCaptureTracks);
    },

    onScreenCaptureError: function(error) {
        console.error("Screen capture error: " + error);

        this.screenDisabled = true;

        if (!this.cameraDisabled) {
            this.setMode("camera");
        }
    },
    
    // #endregion

    // #region Screen Pip

    enableScreenPip: function () {
        var promises = [
            navigator.mediaDevices.getDisplayMedia({
                video: this.options.videoOptions
            }),
            navigator.mediaDevices.getUserMedia({
                audio: this.options.audioOptions,
                video: {
                    width: { ideal: 4096 },
                    height: { ideal: 2160 },
                    aspectRatio: { ideal: 16 / 9 }
                }
            }).catch($empty) // Ignore missing audio
        ];

        Promise.all(promises)
            .then(this.onScreenPipLoad)
            .catch(this.onScreenPipError);
    },

    onScreenPipLoad: function (results) {
        this.desktopStream = results[0];
        this.voiceStream = results[1];

        var { width } = screen;
        var { height } = screen;

        this.merger = new VideoStreamMerger({
            width,
            height
        });
        this.merger.addStream(this.desktopStream, {
            x: 0, // position of the topleft corner
            y: 0,
            width,
            height,
            mute: true // we don't want sound from the screen (if there is any)
        });

        if (this.voiceStream != null) {
            // 16/9 aspect ratio
            var videoHeight = 235;
            var proportionalWidth = (16 / 9) * videoHeight;

            this.merger.addStream(this.voiceStream, {
                x: 0,
                y: this.merger.height - videoHeight,
                width: proportionalWidth,
                height: videoHeight,
                mute: false
            });
        }

        // Start the merging. Calling this makes the result available to us
        this.merger.start();
        this.activeTracks = this.merger.result.getTracks();
        this.setMediaTracks(this.activeTracks);
    },

    onScreenPipError: function (error) {
        console.error("Screen pip capture error: " + error);

        this.screenDisabled = true;

        if (!this.cameraDisabled) {
            this.setMode("camera");
        }
    },

    // #endregion

    setMediaTracks: function(tracks) {
        var mediaStream = this.mediaStream;

        mediaStream.getTracks().forEach(function(track) {
            mediaStream.removeTrack(track);
        });

        tracks.forEach(function(track) {
            mediaStream.addTrack(track);
        });

        this.windowEl.addClass("ready");
        this.windowEl.set("data-mode", this.options.mode);
    },

    onDataAvailable: function(e) {
        this.chunks.push(e.data);
    },

    record: function () {
        this.chunks = [];
        this.recorder.start();

        this.startTimer();

        this.windowEl.removeClass("recorded");
        this.windowEl.addClass("recording");
    },

    stop: function () {
        this.recorder.stop();

        this.stopTimer();

        this.windowEl.removeClass("recording");
        this.windowEl.addClass("recorded");
    },

    onStop: function () {
        var previewEl = this.getElement("previewVideo");
        if (previewEl) {
            var videoFile = this.getVideoFile();
            previewEl.src = URL.createObjectURL(videoFile);
        }
    },

    startTimer: function() {
        this.startTime = new Date().getTime();

        this.updateTimer();

        this.timer = setInterval(this.updateTimer, 1000);
    },

    updateTimer: function() {
        var currentTime = new Date().getTime();
        var duration = (currentTime - this.startTime) / 1000;

        var minutes = Math.trunc(duration / 60).toString();
        if (minutes.length == 1)
            minutes = "0" + minutes;

        var seconds = Math.trunc(duration % 60).toString();
        if (seconds.length == 1)
            seconds = "0" + seconds;

        var timerEl = this.getElement("videoTimer");
        if (timerEl) {
            timerEl.set("text", minutes + ":" + seconds);
        }
    },

    stopTimer: function() {
        clearInterval(this.timer);
    },

    getVideoFile: function () {
        return new Blob(this.chunks);
    },

    getFileName: function() {
        // "yyyymmdd_hhmmss"
        var timestamp = new Date().toISOString().replaceAll('-', '').replaceAll(':', '').replace('T', '_').substring(0, 15);

        return timestamp + ".webm";
    },

    save: function () {
        var file = this.getVideoFile();

        this.options.importOptions.name = file.name = this.getFileName();

        var uploader = new Librarian.Html5Uploader({
            chunkUrl: this.options.chunkUrl,
            completeUrl: this.options.completeUrl,
            importOptions: this.options.importOptions,
            onFileSuccess: this.onSave,
            onFileFailure: this.onSaveError
        }); 

        this.uploadNotification = Librarian.Utils.notification("Uploading video...", false);

        uploader.uploadFile(file);
    },

    onSave: function (file, data) {
        this.uploadNotification.close();

        if (typeof this.options.onComplete == "function") {
            this.options.onComplete(file, data);
        }

        this.close();
    },

    onSaveError: function (file, error) {
        this.uploadNotification.close();
        Librarian.Utils.onFailure(error);
    },

    onClose: function() {
        if (this.cameraTracks) {
            this.cameraTracks.forEach(function(track) {
                track.stop();
            });
        }

        if (this.screenCaptureTracks) {
            this.screenCaptureTracks.forEach(function(track) {
                track.stop();
            });
        }

        if (this.activeTracks) {
            this.activeTracks.forEach(function(track) {
                track.stop();
            });
        }

        if (this.merger) {
            this.merger.destroy();
        }

        if (this.desktopStream) {
            this.desktopStream.getTracks().forEach(function(track) {
                track.stop();
            });
        }

        if (this.voiceStream) {
            this.voiceStream.getTracks().forEach(function(track) {
                track.stop();
            });
        }
    }

});
